import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-us-ui';

const ButtonTabsContainer = styled.div`
  ${EmotionBreakpoint('desktop')} {
    max-width: 970px;
  }
  ${EmotionBreakpoint('tablet')} {
    max-width: 720px;
  }
  ${EmotionBreakpoint('mobile')} {
    .back-to-home {
      margin-left: 25px;
    }
  }
  @media (min-width: 576px) and (max-width: 768px) {
    max-width: 540px;
  }
  margin: auto;
  text-align: left;
  .button-tab-div {
    border-bottom: 1px solid #ccc;
    width: 100%;
  }
  .button-tab {
    font-size: 16px;
    padding: 10px 28px;
    cursor: pointer;
    opacity: 0.6;
    background: white;
    border-width: 0px 0px 2px;
    border-top-style: initial;
    border-right-style: initial;
    border-left-style: initial;
    border-top-color: initial;
    border-right-color: initial;
    border-left-color: initial;
    border-image: initial;
    outline: 0px;
    border-bottom-style: solid;
    border-bottom-color: transparent;
    transition: border-bottom 250ms ease 0s;
  }
  .button-tab:hover {
    border-bottom: ${({ theme }) => `2px solid ${theme.button.primary.backgroundColor}`};
    opacity: 1;
  }
`;

const Breadcrumb = ({ fields }) => {
  return (
    <ButtonTabsContainer>
      <div className="button-tab-div">
        {fields?.blocks.map((item, index) => {
          const openInNewTab = item?.fields?.newTabWindow === true ? '_blank' : '_top';
          return (
            <a href={`https://${location.host}${item?.fields?.url}`} target={openInNewTab}>
              <button className={'button-tab'} key={index}>
                {item?.fields?.text}
              </button>
            </a>
          );
        })}
      </div>
    </ButtonTabsContainer>
  );
};

export { Breadcrumb };
